<template>
<div id="div-already-purchased-container" class="div-lightbox-container">
    <table width="100%" align="left" border="0" cellpadding="0" cellspacing="0">
        <tr>
            <td align="right" colspan="2">
                <a href="javascript:void(0);" onclick="fToggleAlreadyPurchased();">Close</a>
            </td>
        </tr>
        <tr>
            <td class="subhead" colspan="2">
                You Already Purchased Enhanced High Speed
            </td>
        </tr>
        <tr>
            <td class="form-spacer" colspan="2">
            </td>
        </tr>
        <tr>
            <td class="body-copy" colspan="2">
                <p>
                    Your previous purchase of our premium Enhanced High Speed service is still active. You can connect another device-up to 6 total-at no additional charge.
                </p>
            </td>
        </tr>
        <tr>
            <td class="form-spacer" colspan="2">
            </td>
        </tr>
        <tr>
            <td class="form-spacer" colspan="2">
            </td>
        </tr>
        <tr>
            <td class="input-field-label" colspan="2" align="center">
                <button class="button-0" style="width:400px" onclick="fChangePackageAndSubmit('42');">Connect with Enhanced High Speed</button>
            </td>
        </tr>
        <tr>
            <td class="form-spacer" colspan="2">
            </td>
        </tr>
        <tr>
            <td align="right" colspan="2">
            </td>
        </tr>
        <tr>
            <td class="form-spacer">
            </td>
        </tr>
        <tr>
            <td align="left">

            </td>
        </tr>
    </table>
</div>
</template>

<script>

export default {
  name: "AlreadyPurchased"
}

</script>

<style scoped>

</style>